import { Button, Stack, Theme, Typography } from '@mui/material';

import { Page } from '@/components/Layout/Page/Page';
import { OnboardingGuide } from '@/components/OnboardingGuide/OnboardingGuide';

import { useAuthentication } from '@/hooks/useAuthentication';
import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';
import { PROGRESS_STEPS } from '@/utils/progressSteps';

const AddAdultDetailComponent: React.FC = () => {
  const { t } = useTranslate();
  const { onBackToSignIn } = useAuthentication();

  return (
    <Page
      paperProps={{
        color: (theme: Theme) => theme.palette.neutral[1000],
        position: 'right',
        size: 'big',
        children: <OnboardingGuide />,
      }}
      progressProps={PROGRESS_STEPS.thirdPartyComplianceCheckStep}
      hasLogo
    >
      <Stack
        direction="column"
        gap={3}
        flex={1}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Typography variant="body2" textAlign={'center'}>
          {t('page.addAdultDetailResultFailed.content')}
        </Typography>
      </Stack>
      <Button
        onClick={onBackToSignIn}
        {...getDataTestId('back-to-login-button')}
        variant="text"
      >
        {t('layout.page.button.backToLogin')}
      </Button>
    </Page>
  );
};

export default function AddAdultDetailResultFailedPage() {
  return <AddAdultDetailComponent />;
}
